import React from 'react';

import { useLocalizations } from '@vp/ubik-localizations-provider';

import { mailingServicesTemplateFlyoutTypename } from '../types/ppV2ContentfulTypes';

import { MailingServices, MailingServicesContentData } from './mailing-services';
import { PdpFlyoutTrigger } from './PdpFlyoutTrigger';

export type MailingServicesWrapperProps = {
  productKey: string;
  locale: string;
  data: MailingServicesContentData;
};
export const MailingServicesWrapper: React.FC<MailingServicesWrapperProps> = (props) => {
  const { t } = useLocalizations();

  return (
    <MailingServices
      {...props}
      trigger={
        <PdpFlyoutTrigger
          iconType="mail"
          label={t('mailing-list-flyout-link')}
          flyoutType={mailingServicesTemplateFlyoutTypename}
          productKey={props.productKey}
        />
      }
    />
  );
};
